import type { FC, ReactNode } from "react";
import { Navigate } from "react-router";
import { Container } from "../components/Container";
import { useMe } from "../hooks/useMe";

type Props = {
  children: ReactNode;
};

export const AuthGuard: FC<Props> = ({ children }) => {
  const { state } = useMe();

  if (state.loading) {
    return (
      <Container>
        <p className="text-neutral-500 text-sm">読み込み中…</p>
      </Container>
    );
  }

  if (!state.me) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
